import AccountPage from './AccountPage';
import accountPageSagas from './sagas';
import accountPageReducer from './reducer';

export default AccountPage;
export { accountPageSagas, accountPageReducer };
